export const START_HOUR = 0; // 12:00 AM
export const END_HOUR = 24;  // 12:00 AM (Next Day)
export const SLOT_MINUTES = 30;
export const ROW_HEIGHT = 60;

export const formatTime = (value) => {
    if (!value) return '';
    const [hours, minutes] = value.split(':').map(Number);
    const suffix = hours >= 12 && hours < 24 ? 'PM' : 'AM';
    const displayHours = hours % 12 || 12;
    return `${displayHours}:${String(minutes).padStart(2, '0')} ${suffix}`;
};

export const TIME_SLOTS = Array.from({ length: ((END_HOUR - START_HOUR) * 60) / SLOT_MINUTES }, (_, index) => {
    const totalMinutes = START_HOUR * 60 + index * SLOT_MINUTES;
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    const value = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
    return { value, label: formatTime(value) };
});

export const formatDateInput = (date) => {
    const d = new Date(date);
    const offset = d.getTimezoneOffset() * 60000;
    return new Date(d.getTime() - offset).toISOString().split('T')[0];
};

export const formatDateLabel = (value) => {
    return new Intl.DateTimeFormat('en-IN', { weekday: 'short', day: '2-digit', month: 'short', year: 'numeric' }).format(new Date(`${value}T12:00:00`));
};

export const getInitials = (name = '') => {
    return name.split(' ').filter(Boolean).slice(0, 2).map((part) => part[0]).join('').toUpperCase();
};

export const timeToMinutes = (value) => {
    if (!value) return 0;
    const [hours, minutes] = value.split(':').map(Number);
    return hours * 60 + minutes;
};